/**
 * Read-only planogram policy for viewer pages: the Konva stage presents the
 * POG for inspection (pan, zoom, hover) — structure never changes from the
 * canvas, so movement and selection are disabled entirely.
 */
import {
  emptyPlanogramSelection,
  type PlanogramPolicy,
} from "src/components/Planogram/components/KonvaPlanogram";

export const konvaViewerPolicy: PlanogramPolicy = {
  canMove: false,
  canSelect: () => false,
  evaluate: () => ({ allowed: false, reason: "unsupported-movement" }),
  execute: ({ pog, selection }) => ({
    pog,
    selection: selection ?? emptyPlanogramSelection,
    status: "rejected",
    reason: "unsupported-movement",
  }),
};
